import React, { useState } from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'

import { Flex } from 'lese'

const TabsContainer = styled(Flex)`
  background-color: ${colors.background800};
`

const Tabs = ({ children, ...props }) => {
  const [activeTab, setActiveTab] = useState(0)

  const childrenArr = React.Children.toArray(children)

  const tabs = React.cloneElement(childrenArr[0], { setActiveTab, activeTab })
  // TODO: Just display none lol
  return (
    <TabsContainer column {...props}>
      {tabs}
      {childrenArr[activeTab + 1]}
    </TabsContainer>
  )
}

const TabList = ({ setActiveTab, activeTab, children, ...props }) => (
  <Flex {...props}>
    {children.map((child, tabNumber) =>
      React.cloneElement(child, {
        onClick: () => setActiveTab(tabNumber),
        active: tabNumber === activeTab
      })
    )}
  </Flex>
)

const Tab = styled(Flex)`
  justify-content: center;
  padding: 16px 36px;
  cursor: pointer;
  ${({ active }) => active && `background-color: ${colors.background600}`};
`

const TabContent = styled(Flex)`
  padding: 32px 32px 0 32px;
  background-color: ${colors.background600};
`
TabContent.defaultProps = { column: true, separation: '16px' }

export { Tabs, TabList, Tab, TabContent }
